import React, { useEffect, useState } from 'react';
import './css/WashingMachine.css';

import Navbar from './components/Navbar';
import Newsletter from './components/NewsLetter';
import Footer from './components/Footer';

import WashingMachineHeroBg from '../images/HomeBgBanner.png';
import DownloadApp from './components/DownloadApp';

import { ref, onValue, get } from "firebase/database";
import { db, auth } from "../firebase";
import { onAuthStateChanged } from "firebase/auth";

import { FaStar, FaArrowRight, FaTags, FaTimes } from "react-icons/fa";

function WashingMachine() {

    const [services, setServices] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedService, setSelectedService] = useState(null);
    const [bookingService, setBookingService] = useState(null);

    const [showLoginRequiredModal, setShowLoginRequiredModal] = useState(false);

    const [showRegistrationModal, setShowRegistrationModal] = useState(false);

    const [currentUser, setCurrentUser] = useState(null);

    useEffect(() => {

        const unsubscribe = onAuthStateChanged(auth, (user) => {
            setCurrentUser(user || null);
        });

        return () => unsubscribe();

    }, []);

    useEffect(() => {

        const servicesRef = ref(db, "fixovera-services");

        const unsubscribe = onValue(
            servicesRef,
            (snapshot) => {

                const data = snapshot.val();

                if (data) {

                    const filteredServices = Object.entries(data)
                        .map(([id, service]) => ({
                            id,
                            ...service
                        }))
                        .filter(
                            (service) =>
                                service.subCategoryName === "Washing Machine Repairing" &&
                                service.active === true &&
                                service.status === "active"
                        );

                    setServices(filteredServices);

                } else {

                    setServices([]);

                }

                setLoading(false);
            },
            (error) => {

                console.error("Error fetching Washing Machine services:", error);
                setLoading(false);

            }
        );

        return () => unsubscribe();

    }, []);
    // Calculate discounted price
    const getDiscountedPrice = (price, discount) => {

        if (!price) return 0;

        if (!discount || discount <= 0) {
            return price;
        }

        return Math.round(price - (price * discount) / 100);
    };

    const handleBookService = async (service) => {

        try {

            // First check Firebase Authentication
            if (!currentUser) {

                setBookingService(service);
                setShowLoginRequiredModal(true);

                return;
            }


            // Check Fixovera user database
            const userRef = ref(
                db,
                `fixovera-users/${currentUser.uid}`
            );

            const snapshot = await get(userRef);


            // Authenticated but not registered as Fixovera user
            if (!snapshot.exists()) {

                setBookingService(service);
                setShowLoginRequiredModal(true);

                return;
            }


            // User is authenticated and exists
            console.log(
                "Eligible to book:",
                service
            );

            // Actual booking flow will come here later

        } catch (error) {

            console.error(
                "Error checking Fixovera user:",
                error
            );

            setBookingService(service);
            setShowLoginRequiredModal(true);
        }
    };

    return (
        <div className="WashingMachine-page-wrapper">

            {/* Hero Section */}
            <section
                className="WashingMachine-hero-section"
                style={{
                    backgroundImage: `url(${WashingMachineHeroBg})`
                }}
            >
                <Navbar />
            </section>


            {/* Main Washing Machine Services Section */}
            <section className="WashingMachine-main-section">

                <div className="container">

                    {/* Section Header */}
                    <div className="row justify-content-center text-center mb-5">

                        <div className="col-lg-8">

                            <span className="WashingMachine-section-mini-tag">
                                Washing Machine SERVICES
                            </span>

                            <h2 className="WashingMachine-section-heading">
                                Professional Washing Machine Services at Your Doorstep
                            </h2>

                            <p className="WashingMachine-section-subtext mt-3">
                                Keep your air conditioner running smoothly with reliable
                                Washing Machine cleaning, servicing, repair and maintenance services
                                from trusted professionals through Fixovera.
                            </p>

                            <div className="zigzag-border mx-auto mt-3"></div>

                        </div>

                    </div>


                    {/* Services */}
                    <div className="row g-4">

                        {loading ? (

                            <div className="col-12 text-center py-5">

                                <div
                                    className="spinner-border"
                                    role="status"
                                    style={{
                                        color: "#207AB4"
                                    }}
                                >
                                    <span className="visually-hidden">
                                        Loading...
                                    </span>
                                </div>

                                <p className="mt-3">
                                    Loading Washing Machine services...
                                </p>

                            </div>

                        ) : services.length === 0 ? (

                            <div className="col-12">

                                <div className="WashingMachine-empty-state text-center">

                                    <h4>
                                        No Washing Machine Services Available
                                    </h4>

                                    <p>
                                        We're currently updating our Washing Machine services.
                                        Please check again soon.
                                    </p>

                                </div>

                            </div>

                        ) : (

                            services.map((service) => {

                                const discountedPrice =
                                    getDiscountedPrice(
                                        Number(service.price),
                                        Number(service.discount)
                                    );

                                return (

                                    <div
                                        className="col-lg-4 col-md-6"
                                        key={service.id}
                                    >

                                        <div className="WashingMachine-service-card">

                                            {/* Service Image */}
                                            <div className="WashingMachine-service-image-wrapper">

                                                {service.image ? (

                                                    <img
                                                        src={service.image}
                                                        alt={service.name || "Washing Machine Service"}
                                                        className="WashingMachine-service-image"
                                                    />

                                                ) : (

                                                    <div className="WashingMachine-image-placeholder">
                                                        Washing Machine
                                                    </div>

                                                )}

                                                {service.discount > 0 && (

                                                    <div className="WashingMachine-discount-badge">
                                                        <FaTags />
                                                        {service.discount}% OFF
                                                    </div>

                                                )}

                                            </div>


                                            {/* Service Content */}
                                            <div className="WashingMachine-service-content">

                                                <div className="d-flex justify-content-between align-items-start gap-2">

                                                    <h4 className="WashingMachine-service-title">
                                                        {service.name || "Washing Machine Service"}
                                                    </h4>

                                                    <div className="WashingMachine-rating">

                                                        <FaStar />

                                                        <span>
                                                            {Number(service.rating || 0).toFixed(1)}
                                                        </span>

                                                    </div>

                                                </div>


                                                {/* Subcategory */}
                                                {service.gstSubCategoryName && (

                                                    <span className="WashingMachine-service-category">

                                                        {service.gstSubCategoryName}

                                                    </span>

                                                )}


                                                {/* Description */}
                                                <p className="WashingMachine-service-description">

                                                    {service.steps?.[0]?.description ||
                                                        "Professional Washing Machine service performed by experienced service professionals."}

                                                </p>


                                                {/* Price */}
                                                <div className="WashingMachine-price-section">

                                                    <div>

                                                        {service.discount > 0 && (

                                                            <span className="WashingMachine-original-price">
                                                                ₹{Number(service.price).toLocaleString("en-IN")}
                                                            </span>

                                                        )}

                                                        <span className="WashingMachine-current-price">
                                                            ₹{discountedPrice.toLocaleString("en-IN")}
                                                        </span>

                                                    </div>

                                                </div>


                                                {/* Book Button */}
                                                <div className="WashingMachine-action-buttons">

                                                    <button
                                                        type="button"
                                                        className="WashingMachine-details-button"
                                                        onClick={() => setSelectedService(service)}
                                                    >
                                                        Details
                                                    </button>

                                                    <button
                                                        type="button"
                                                        className="WashingMachine-book-button"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleBookService(service);
                                                        }}
                                                    >
                                                        Book Service
                                                        <FaArrowRight />
                                                    </button>

                                                </div>

                                            </div>

                                        </div>

                                    </div>

                                );

                            })

                        )}

                    </div>

                </div>

            </section>


            {/* Download App */}
            <DownloadApp />

            {/* ==========================================
    SERVICE DETAILS MODAL
========================================== */}

            {selectedService && (

                <div
                    className="WashingMachine-modal-overlay"
                    onClick={() => setSelectedService(null)}
                >

                    <div
                        className="WashingMachine-service-modal"
                        onClick={(e) => e.stopPropagation()}
                    >

                        {/* ==================================
                MODAL HEADER
            ================================== */}

                        <div className="WashingMachine-modal-header">

                            <div className="WashingMachine-modal-title-area">

                                <span className="WashingMachine-modal-category">
                                    {selectedService.categoryName || "Home Service"}
                                </span>

                                <h2>
                                    {selectedService.subCategoryName || "Service"}
                                </h2>

                                <h3>
                                    {selectedService.name || "Service Name"}
                                </h3>

                            </div>

                            <button
                                type="button"
                                className="WashingMachine-modal-close"
                                onClick={() => setSelectedService(null)}
                                aria-label="Close"
                            >
                                <FaTimes />
                            </button>

                        </div>


                        {/* ==================================
                SERVICE IMAGE
            ================================== */}

                        <div className="WashingMachine-modal-image-section">

                            {selectedService.image ? (

                                <img
                                    src={selectedService.image}
                                    alt={selectedService.name || "Service"}
                                />

                            ) : (

                                <div className="WashingMachine-modal-image-placeholder">
                                    {selectedService.name || "Service"}
                                </div>

                            )}

                        </div>


                        {/* ==================================
                SERVICE INFORMATION
            ================================== */}

                        <div className="WashingMachine-modal-content">

                            <h3 className="WashingMachine-modal-section-title">
                                Service Information
                            </h3>

                            <div className="WashingMachine-detail-grid">

                                <div className="WashingMachine-detail-box detail-blue">
                                    <span>Service ID</span>
                                    <strong>
                                        {selectedService.id || "-"}
                                    </strong>
                                </div>

                                <div className="WashingMachine-detail-box detail-yellow">
                                    <span>Category</span>
                                    <strong>
                                        {selectedService.categoryName || "-"}
                                    </strong>
                                </div>

                                <div className="WashingMachine-detail-box detail-teal">
                                    <span>Sub Category</span>
                                    <strong>
                                        {selectedService.subCategoryName || "-"}
                                    </strong>
                                </div>

                                <div className="WashingMachine-detail-box detail-purple">
                                    <span>Price</span>
                                    <strong>
                                        ₹{Number(selectedService.price || 0).toLocaleString("en-IN")}
                                    </strong>
                                </div>

                                <div className="WashingMachine-detail-box detail-blue">
                                    <span>Discount</span>
                                    <strong>
                                        {Number(selectedService.discount || 0)}%
                                    </strong>
                                </div>

                                {/* <div className="WashingMachine-detail-box detail-yellow">
                                    <span>Status</span>
                                    <strong className="text-capitalize">
                                        {selectedService.status || "-"}
                                    </strong>
                                </div>

                                <div className="WashingMachine-detail-box detail-teal">
                                    <span>Created</span>
                                    <strong>
                                        {selectedService.createdAt || "-"}
                                    </strong>
                                </div> */}

                                <div className="WashingMachine-detail-box detail-purple">
                                    <span>GST Category</span>
                                    <strong>
                                        {selectedService.gstCategoryName || "-"}
                                    </strong>
                                </div>

                                <div className="WashingMachine-detail-box detail-blue">
                                    <span>GST Sub Category</span>
                                    <strong>
                                        {selectedService.gstSubCategoryName || "-"}
                                    </strong>
                                </div>

                                <div className="WashingMachine-detail-box detail-yellow">
                                    <span>SAC Code</span>
                                    <strong>
                                        {selectedService.gstSacCode || "-"}
                                    </strong>
                                </div>

                                <div className="WashingMachine-detail-box detail-teal">
                                    <span>GST</span>
                                    <strong>
                                        {Number(selectedService.gstPercentage || 0)}%
                                    </strong>
                                </div>

                                <div className="WashingMachine-detail-box detail-purple">
                                    <span>GST Amount</span>
                                    <strong>
                                        ₹{(
                                            Number(selectedService.price || 0) *
                                            Number(selectedService.gstPercentage || 0) /
                                            100
                                        ).toLocaleString("en-IN", {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        })}
                                    </strong>
                                </div>

                            </div>


                            {/* ==================================
                    TOTAL PRICE
                ================================== */}

                            <div className="WashingMachine-total-price-box">

                                <span>
                                    Total Service Amount (Including GST)
                                </span>

                                <strong>
                                    ₹{(
                                        Number(selectedService.price || 0) +
                                        (
                                            Number(selectedService.price || 0) *
                                            Number(selectedService.gstPercentage || 0) /
                                            100
                                        )
                                    ).toLocaleString("en-IN", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    })}
                                </strong>

                            </div>


                            {/* ==================================
                    SERVICE STEPS
                ================================== */}

                            <h3 className="WashingMachine-modal-section-title steps-title">
                                Service Steps
                            </h3>

                            {selectedService.steps &&
                                Object.values(selectedService.steps).length > 0 ? (

                                <div className="WashingMachine-steps-container">

                                    {Object.values(selectedService.steps).map(
                                        (step, index) => (

                                            <div
                                                className={`WashingMachine-step-box ${index % 4 === 0
                                                    ? "step-blue"
                                                    : index % 4 === 1
                                                        ? "step-yellow"
                                                        : index % 4 === 2
                                                            ? "step-teal"
                                                            : "step-purple"
                                                    }`}
                                                key={index}
                                            >

                                                <div className="WashingMachine-step-number">
                                                    {index + 1}
                                                </div>

                                                <div className="WashingMachine-step-content">

                                                    <h4>
                                                        {step.title || `Step ${index + 1}`}
                                                    </h4>

                                                    <p>
                                                        {step.description || ""}
                                                    </p>

                                                </div>

                                                {step.image && (

                                                    <div className="WashingMachine-step-image">

                                                        <img
                                                            src={step.image}
                                                            alt={
                                                                step.title ||
                                                                `Service Step ${index + 1}`
                                                            }
                                                        />

                                                    </div>

                                                )}

                                            </div>

                                        )
                                    )}

                                </div>

                            ) : (

                                <div className="WashingMachine-no-steps">
                                    No service steps available.
                                </div>

                            )}

                        </div>


                        {/* ==================================
                MODAL FOOTER
            ================================== */}

                        <div className="WashingMachine-modal-footer">

                            <button
                                type="button"
                                className="WashingMachine-modal-close-button"
                                onClick={() => setSelectedService(null)}
                            >
                                Close
                            </button>

                            <button
                                type="button"
                                className="WashingMachine-book-button"
                                onClick={() => {
                                    setSelectedService(null);
                                    handleBookService(selectedService);
                                }}
                            >
                                Book Service
                                <FaArrowRight />
                            </button>

                        </div>

                    </div>

                </div>

            )}

            {showLoginRequiredModal && (
                <div
                    className="WashingMachine-modal-overlay"
                    onClick={() => setShowLoginRequiredModal(false)}
                >

                    <div
                        className="WashingMachine-login-modal"
                        onClick={(e) => e.stopPropagation()}
                    >

                        {/* Header */}
                        <div className="WashingMachine-login-modal-header">

                            <div>
                                <span className="WashingMachine-login-mini-tag">
                                    FIXOVERA
                                </span>

                                <h3>
                                    Login Required
                                </h3>
                            </div>

                            <button
                                type="button"
                                className="WashingMachine-modal-close"
                                onClick={() => setShowLoginRequiredModal(false)}
                            >
                                ×
                            </button>

                        </div>


                        {/* Content */}
                        <div className="WashingMachine-login-modal-body">

                            <div className="WashingMachine-login-icon">
                                <FaArrowRight />
                            </div>

                            <h4>
                                Avail This Service
                            </h4>

                            <p>
                                To book this service, please login to your
                                existing Fixovera account or register with us
                                to continue.
                            </p>

                            {selectedService && (
                                <div className="WashingMachine-selected-service">

                                    <strong>
                                        {selectedService.name}
                                    </strong>

                                    <span>
                                        ₹
                                        {getDiscountedPrice(
                                            Number(selectedService.price),
                                            Number(selectedService.discount)
                                        ).toLocaleString("en-IN")}
                                    </span>

                                </div>
                            )}

                        </div>


                        {/* Buttons */}
                        <div className="WashingMachine-login-modal-actions">

                            {/* Login Button */}
                            <button
                                type="button"
                                className="WashingMachine-login-button"
                                onClick={() => {
                                    setShowLoginRequiredModal(false);

                                    window.open(
                                        "https://booking.fixovera.com/",
                                        "_blank",
                                        "noopener,noreferrer"
                                    );
                                }}
                            >
                                Login
                            </button>


                            {/* Register Button */}
                            <button
                                type="button"
                                className="WashingMachine-register-button"
                                onClick={() => {
                                    setShowLoginRequiredModal(false);

                                    window.open(
                                        "https://booking.fixovera.com/register",
                                        "_blank",
                                        "noopener,noreferrer"
                                    );
                                }}
                            >
                                Register With Us
                            </button>

                        </div>

                    </div>

                </div>
            )}

            {showRegistrationModal && (
                <div
                    className="WashingMachine-modal-overlay"
                    onClick={() => setShowRegistrationModal(false)}
                >

                    <div
                        className="WashingMachine-registration-modal"
                        onClick={(e) => e.stopPropagation()}
                    >

                        <div className="WashingMachine-login-modal-header">

                            <div>

                                <span className="WashingMachine-login-mini-tag">
                                    FIXOVERA
                                </span>

                                <h3>
                                    Register With Us
                                </h3>

                            </div>

                            <button
                                type="button"
                                className="WashingMachine-modal-close"
                                onClick={() => setShowRegistrationModal(false)}
                            >
                                ×
                            </button>

                        </div>


                        {/* Blank Registration Area */}
                        <div className="WashingMachine-registration-content">

                            {/* Registration form will be added here */}

                        </div>

                    </div>

                </div>
            )}


            {/* Global Bottom Components */}
            <Newsletter />

            <Footer />

        </div>
    );
}

export default WashingMachine;